// extracted by mini-css-extract-plugin
export default {"login_wrapper":"styles_login_wrapper__p2zEQ","login_window":"styles_login_window__tqaoQ"};